import { useQuery } from "@tanstack/react-query";
import { StaffPostService } from "../services/staffPost.request";

export const useQueryStaffPostForSelect = (params?: any) => {
  return useQuery({
    queryKey: ["staffPost"],
    queryFn: async () => await StaffPostService.getAllStaffPostSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member;
      } else {
        return [];
      }
    },
  });
};
